import Request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 接口信息
   */
  static getWalletInfo() {
    return Request({
      url: `wallet/queryAccounts`,
      host: config.HOST_MALL
    });
  }

  /**
   * 获取最新一项明细
   */
  static getLatestTransaction() {
    return Request({
      url: `wallet/queryAccountTradeInfos/0/1/1`,
      host: config.HOST_MALL
    });
  }

  /**
   * 获取各种优惠券数量
   */
  static getCouponCount(params) {
    return Request({
      url: `coupon/count`,
      host: config.HOST_MALL,
      method: 'post_json',
      data: params
    });
  }

  /**
   * 获取提现列表
   */
  static getWithDrawList(params) {
    return Request({
      url: `fiance/personal/queryApproves`,
      host: config.HOST_MALL,
      method: 'get',
      params
    });
  }

  /**
   * 获取是否可提现
   */
  static geCheckWithDraw() {
    return Request({
      url: `wallet/verify/withdraw`,
      host: config.HOST_MALL,
      method: 'POST'
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/Wallet/NomalWallet/NomalWalletServ.js